import React, { useState, Fragment } from 'react';
import Modal from '../../common/Modal';
import Form from './Form'

const NotesModal = ({ type, value, id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const renderModal = () => {
    if (!isOpen) return;

    return (
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Post a Note"
        headerText="Post a Note to Photographers"
      >
        <Form type={type} value={value} id={id} />
      </Modal>
    )
  }

  return (
    <Fragment>
      {renderModal()}
      <a onClick={openModal} className="btn btn-primary">Update Note</a>
    </Fragment>
  )
}

export default NotesModal;
